var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 1.666h-1.333V1A.666.666 0 109 1v.666H5V1a.667.667 0 10-1.334 0v.666H2.333a2 2 0 00-2 2v8a2 2 0 002 2h9.333a2 2 0 002-2v-8a2 2 0 00-2-2zm.667 10a.666.666 0 01-.667.667H2.333a.666.666 0 01-.667-.667V7h10.667v4.666zm0-6H1.666v-2A.667.667 0 012.333 3h1.333v.666a.667.667 0 001.334 0V3h4v.666a.667.667 0 001.333 0V3h1.333a.666.666 0 01.667.666v2z",
    fill: "#fff"
  })));
}
export default SvgCalendar;